/** Status constants for the applicant list as enum */
export enum ApplicantStatus {
  NEW = 1,
  VIEWED = 2,
  INTERVIEW = 3,
  REJECTED = 4,
  SHORTLIST = 21,
  HIRED = 22,
  OFFER = 23,
  RECOMMENDED = 24,
}

/** Status constants for the applicant list as an object with label */
export const applicantStatusIdObj = [
  { // new
    statusId: 1,
    color: 'light',
    label: 'applicant.status.1',
  },
  { // interview
    statusId: 3,
    color: 'secondary',
    label: 'applicant.status.3',
  },
  { // rejected
    statusId: 4,
    color: 'error',
    label: 'applicant.status.4',
  },
  { // shortlist
    statusId: 21,
    color: 'primary-light',
    label: 'applicant.status.21',
  },
  { // hired
    statusId: 22,
    color: 'secondary-light',
    label: 'applicant.status.22',
  },
  { // offer
    statusId: 23,
    color: 'pink',
    label: 'applicant.status.23',
  },
  { // recommended
    statusId: 24,
    color: 'warning',
    label: 'applicant.status.24',
  },
];

/**
 * @description Status constants for the applicant board STATUS path parameter.
 * Combine them with the 'filterStatus' query parameters.
 *
 * **Combinations**
 * - `rejected` = all applicants;
 * - `rejected` + `bsf_unselected` = unselected applicants;
 * - `rejected` + `bsf_rejected` = rejected applicants;
 *
 * - `qualified` = shortlisted applicants;
 * - `qualified` + `bsf_recommended` = recommended applicants;
 *
 * - `extended_selected` + `bsf_interview` = interview applicants;
 * - `extended_selected` + `bsf_offer` = offer applicants;
 * - `extended_selected` + `bsf_hire` = hired applicants;
 */
export enum ApplicantBoardPathStatus {
  REJECTED = 'rejected',
  QUALIFIED = 'qualified',
  SELECTED = 'selected',
  ACCEPTED = 'accepted',
  EXTENDED_SELECTED = 'extended_selected',
}

/**
 * @description Status constants for the applicant board filterStatus query parameter.
 * Combine them with the 'status' path parameter.
 */
export enum ApplicantBoardQueryFilterStatus {
  'BSF_UNSELECTED' = 'bsf_unselected',
  'BSF_REJECTED' = 'bsf_rejected',
  'BSF_INTERVIEW' = 'bsf_interview',
  'BSF_OFFER' = 'bsf_offer',
  'BSF_HIRE' = 'bsf_hire',
}
